import Header from './components/Header';
import HeroSection from './components/HeroSection';
import { MediaSection, FaqSection, UpdatesSection } from './components/SectionsPart1';
import { CommentsSection, TopicsSection, RankingSection } from './components/SectionsPart2';
import { FeaturesSection, ContactSection, AboutSection, IndexSection, AppSection } from './components/SectionsPart3';
import { CardsSection, CarouselSection } from './components/SectionsPart4';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <MediaSection />
        <FaqSection />
        <UpdatesSection />
        <CommentsSection />
        <TopicsSection />
        <RankingSection />
        <FeaturesSection />
        <ContactSection />
        <AboutSection />
        <IndexSection />
        <AppSection />
        <CardsSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}